module.exports = __webpack_public_path__ + "websocket.9348a781bc473227e0d5.worker.js"